module.exports = __webpack_public_path__ + "img/ico_shopping.8304ee6a.svg";